// custom enums

import { STATUS_TYPE } from "../../enums/ads/status-types";

export const ListOFAdsStatus = [
    {name: 'الجديد', id: STATUS_TYPE.N},
    {name: 'قيد التقدم', id: STATUS_TYPE.PR},
    {name: 'مكتمل', id: STATUS_TYPE.COM},
    {name: 'منتهي', id: STATUS_TYPE.CAN},
  ]